import { render, staticRenderFns } from "./ToDo.vue?vue&type=template&id=0a9f8373&scoped=true"
import script from "./ToDo.vue?vue&type=script&lang=js"
export * from "./ToDo.vue?vue&type=script&lang=js"
import style0 from "./ToDo.vue?vue&type=style&index=0&id=0a9f8373&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9f8373",
  null
  
)

export default component.exports